import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(to bottom, #003177 0, #2989d8 42%, #2989d8 51%, #207cca 63%, #0055a5 100%);
  padding: 15px;
  min-height: 100vh;
`;
